// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2Wdfu","header":"PatientQuestionnaire_header__2yj6O","info":"PatientQuestionnaire_info__35Jxb"};